import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import TopBar from 'elements/TopBar/TopBar';
import { getSantoralLabel } from 'hooks/useLabels';
import { getHsfLabel } from 'utils/hsfSantoral';

export default function SantoralCategories(props: any) {
  useEffect(() => {
    // La navegación global activa el overlay antes de entrar a /santoral.
    // Esta pantalla no hace peticiones al cargar, así que debe liberarlo al montar.
    props.setLoading(false);
  }, [props.setLoading]);

  return (
    <div id="SantoralCategories" className="module_container">
      <div className="module_topBar">
        <TopBar title={getSantoralLabel('santoral_titulo')} />
      </div>

      <div className="module_content">
        <div id="Santoral_categories" className="flex_column">
          <div className="CardList">
            <Link
              to="/santoral/calendario-romano"
              className="icon"
              onClick={() => props.setLoading(true)}
            >
              <span className="CardListTitle">
                {getSantoralLabel('calendario_romano_general')}
              </span>
            </Link>
          </div>

          <div className="CardList">
            <Link
              to="/santoral/martirologio"
              className="icon"
            >
              <span className="CardListTitle">
                {getSantoralLabel('martirologio_romano')}
              </span>
            </Link>
          </div>
          <div className="CardList">
            <Link to="/santoral/hijos-sagrada-familia" className="icon" onClick={() => props.setLoading(true)}>
              <span className="CardListTitle">{getHsfLabel('title')}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
